import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NetworkThrottleService } from '../libs/network-throttle.service';
import { delay } from 'rxjs';

export const networkThrottleInterceptor: HttpInterceptorFn = (req, next) => {
  const throttleService = inject(NetworkThrottleService);
  const delayTime = throttleService.getDelayTime();

  if (delayTime > 0) {
    return next(req).pipe(delay(delayTime));
  }

  return next(req);
};
